import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
    alert('Cảm ơn bạn đã liên hệ! Chúng tôi sẽ phản hồi trong thời gian sớm nhất.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });
  };

  return (
    <div className="contact-page">
      <div className="container">
        {/* Page Header */}
        <section className="page-header">
          <h1>Liên hệ với chúng tôi</h1>
          <p>Hãy để lại thông tin, chúng tôi sẽ liên hệ tư vấn miễn phí</p>
        </section>

        <div className="contact-content">
          {/* Contact Info */}
          <div className="contact-info">
            <h2>Thông tin liên hệ</h2>
            
            <div className="info-item">
              <div className="info-icon">📍</div>
              <div className="info-details">
                <h4>Trụ sở chính</h4>
                <p>Số 4/A1 Chung cư Tinh Thành Quốc tế, Khu đô thị Cựu Viên, Phường Kiến An, Thành phố Hải Phòng, Việt Nam</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">🔬</div>
              <div className="info-details">
                <h4>Trung tâm thí nghiệm</h4>
                <p>Vật liệu và khảo sát địa chất LAS-XD27.004</p>
                <p>Giấy chứng nhận số 3335/GCN-SXD ngày 05/7/2024</p>
                <p>Địa chỉ: Lô 258 - dự án An Đồng – Phường An Hải – Thành phố Hải Phòng</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">📧</div>
              <div className="info-details">
                <h4>Email</h4>
                <p>mienbacdsc@gmail.com</p>
                <p>Website: tracdiahaiphong.com</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">📞</div>
              <div className="info-details">
                <h4>Điện thoại</h4>
                <p>Tel/Fax: 0225.3920691</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">🕒</div>
              <div className="info-details">
                <h4>Giờ làm việc</h4>
                <p>Thứ 2 - Thứ 6: 8:00 - 17:00</p>
                <p>Thứ 7: 8:00 - 12:00</p>
                <p>Chủ nhật: Nghỉ</p>
              </div>
            </div>

            <div className="company-details">
              <h3>Thông tin công ty</h3>
              <ul>
                <li><strong>Tên công ty:</strong> Công ty Cổ phần Khảo sát Thiết kế và Dịch vụ Thương mại Miền Bắc</li>
                <li><strong>Tên tiếng Anh:</strong> MIENBAC TRANDING SERVICE AND DESIGN SURVEY JOINT STOCK COMPANY</li>
                <li><strong>Tên viết tắt:</strong> DSC.JSC</li>
                <li><strong>Mã số thuế:</strong> 0200647813</li>
                <li><strong>Người đại diện:</strong> Ông Vũ Văn Đáp - Chủ tịch HĐQT (kiêm Giám Đốc)</li>
                <li><strong>Website:</strong> tracdiahaiphong.com</li>
              </ul>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            <h2>Gửi yêu cầu tư vấn</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Họ và tên *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Nhập họ và tên của bạn"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="email@example.com"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Số điện thoại</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="02 253 920 691"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="service">Dịch vụ quan tâm</label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                >
                  <option value="">Chọn dịch vụ</option>
                  <option value="khao-sat">Khảo sát địa hình</option>
                  <option value="thiet-ke">Thiết kế kỹ thuật</option>
                  <option value="tu-van">Tư vấn giám sát</option>
                  <option value="thuong-mai">Dịch vụ thương mại</option>
                  <option value="lap-du-an">Lập dự án đầu tư</option>
                  <option value="dao-tao">Đào tạo chuyên môn</option>
                  <option value="khac">Khác</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Nội dung *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Mô tả chi tiết yêu cầu của bạn..."
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Gửi yêu cầu
              </button>
            </form>
          </div>
        </div>

       
        {/* FAQ Section */}
        <section className="faq-section">
          <h2>Câu hỏi thường gặp</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Thời gian thực hiện dự án như thế nào?</h4>
              <p>Thời gian thực hiện phụ thuộc vào quy mô và độ phức tạp của dự án. Chúng tôi sẽ cam kết thời gian cụ thể sau khi khảo sát.</p>
            </div>
            <div className="faq-item">
              <h4>Chi phí dịch vụ được tính như thế nào?</h4>
              <p>Chi phí được tính dựa trên khối lượng công việc, độ phức tạp và thời gian thực hiện. Chúng tôi báo giá minh bạch và cạnh tranh.</p>
            </div>
            <div className="faq-item">
              <h4>Có hỗ trợ tư vấn miễn phí không?</h4>
              <p>Có, chúng tôi cung cấp tư vấn miễn phí ban đầu để hiểu rõ nhu cầu và đưa ra giải pháp phù hợp.</p>
            </div>
            <div className="faq-item">
              <h4>Khu vực phục vụ của công ty?</h4>
              <p>Chúng tôi chủ yếu phục vụ tại Hải Phòng và các tỉnh miền Bắc. Có thể mở rộng ra các khu vực khác theo yêu cầu.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;